import { useReward } from '@/contexts/reward-context';
import { RewardModalWrapper } from './reward-modal-wrapper';
import { CloseIcon } from './svg-icons';
import { RewardScene } from '@/types';

export const RfbInfo = () => {
	const { labels, setRewardScene } = useReward();
	const onClose = () => {
		setRewardScene(RewardScene.Shop);
	};

	return (
		<RewardModalWrapper>
			<div className="shop-info-modal" >
				<div className="shop-info-modal__header">
					<div className="shop-info-modal__title">
						{labels?.lbl_newRFB02}
					</div>
					<div
						className="shop-info-modal__close"
						onClick={onClose}
					>
						<CloseIcon />
					</div>
				</div>
				<div className="shop-info-modal__content">
					<div className="shop-info-modal__text" dangerouslySetInnerHTML={{ __html: labels?.lbl_newRFB03 ?? '' }}>
					</div>
					<div className="shop-info-modal__list-item">
						<li>{labels?.lbl_newRFB04} </li>
						<li>{labels?.lbl_newRFB05} </li>
						<li>{labels?.lbl_newRFB06} </li>
						<li>{labels?.lbl_newRFB07} </li>
					</div>
					<div className="shop-info-modal__text">{labels?.lbl_newRFB08}</div>
					<div className="shop-info-modal__text">{labels?.lbl_newRFB09}</div>
				</div>
			</div>
		</RewardModalWrapper>
	)
};
